import { render, staticRenderFns } from "./RoutineList.vue?vue&type=template&id=2b890300&"
import script from "./RoutineList.vue?vue&type=script&lang=js&"
export * from "./RoutineList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports